import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { MACS_IQ_VIEW_CONVERTER_TOKEN, MacsIqViewConverter } from './macs-iq-view.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        macsIQViewFeature: {
          module: () => import('./macs-iq-view.module').then((m) => m.MacsIqViewModule),
          cmsComponents: ['macs_iq_view'],
        },
      }
    }),
    {
      provide: MACS_IQ_VIEW_CONVERTER_TOKEN,
      useExisting: MacsIqViewConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        macs_iq_view: MACS_IQ_VIEW_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class MacsIqViewFeatureModule {}
